export default function processEvent(event, processedEvents) {
  const newEvent = {
    name: event.summary,
    description: event.description,
    location: event.location,
    year: 0,
    month: 0,
    day: 0,
    startHour: 0,
    startMinutes: 0,
  };

  try {
    if (event.hasOwnProperty("start")) {
      if (event.start.hasOwnProperty("dateTime")) {
        newEvent.year = parseInt(event.start.dateTime.slice(0, 4));
        newEvent.month = parseInt(event.start.dateTime.slice(5, 7)) - 1;
        newEvent.day = parseInt(event.start.dateTime.slice(8, 10));
        newEvent.startHour = parseInt(event.start.dateTime.slice(11, 13));
        newEvent.startMinutes = parseInt(event.start.dateTime.slice(14, 16));
      } else {
        newEvent.year = parseInt(event.start.date.slice(0, 4));
        newEvent.month = parseInt(event.start.date.slice(5, 7)) - 1;
        newEvent.day = parseInt(event.start.date.slice(8, 10));
      }
    } else {
      newEvent.year = parseInt(event.originalStartTime.dateTime.slice(0, 4));
      newEvent.month =
        parseInt(event.originalStartTime.dateTime.slice(5, 7)) - 1;
      newEvent.day = parseInt(event.originalStartTime.dateTime.slice(8, 10));
    }
  } catch (error) {
    console.log(error);
  }
  processedEvents.push(newEvent);
}
